/**
 * Redux reducer for saved items.
 * @module redux/reducers/savedItem
 */

import update from 'immutability-helper';

import {
  CONTEXT_CHANGED,
  REQUEST_FOLDERS,
  FOLDERS_REQUEST_FAILED,
  FOLDER_SELECTED,
  FOLDER_REMOVED,
  SORT_BY_CHANGED,
  BEGIN_SAVED_ITEMS_REQUEST,
  RECEIVED_SAVED_ITEMS,
  SAVED_ITEMS_REQUEST_FAILED,
  PAGE_CHANGED,
  RELOAD,
  CLEAR_SAVED_ITEMS,
  RECEIVED_FOLDERS,
  LOAD_SAVED_ITEM,
  SAVED_ITEM_LOADED,
  LOAD_SAVED_ITEM_FAILED,
  SAVED_ITEM_REMOVED,
  SEARCH_TERMS_CHANGED
} from '../actions/savedItems';
import SortOption from '../constants/sortOptions';

import { CONTEXT_CHANGED as ASSET_CONTEXT_CHANGED } from '../actions/assets';

const initialState = {
  contextId: -1,
  searchTerms: '',
  pageNumber: 1,
  totalPages: 1,
  sortBy: SortOption.MOST_RECENT,
  savedItemsLoading: false,
  savedItemLoading: false,
  foldersLoading: false,
  needUpdate: false,
  selectedFolder: null,
  savedItems: []
};

const ACTION_HANDLERS = {
  [CONTEXT_CHANGED]: (state, action) => ({
    ...state,
    contextId: !isNaN(action.payload.contextId) ? parseInt(action.payload.contextId, 10) : -1,
    pageNumber: 1,
    needUpdate: true
  }),
  [ASSET_CONTEXT_CHANGED]: (state, action) => ({
    ...state,
    contextId: !isNaN(action.payload.contextId) ? parseInt(action.payload.contextId, 10) : -1,
    pageNumber: 1,
    needUpdate: true
  }),
  [SEARCH_TERMS_CHANGED]: (state, action) => ({
    ...state,
    searchTerms: action.payload.searchTerms,
    pageNumber: 1,
    needUpdate: true
  }),
  [BEGIN_SAVED_ITEMS_REQUEST]: state => ({
    ...state,
    savedItemsLoading: true,
    savedItems: []
  }),
  [SAVED_ITEMS_REQUEST_FAILED]: state => ({
    ...state,
    savedItemsLoading: false,
    needUpdate: false
  }),
  [RECEIVED_SAVED_ITEMS]: (state, action) => ({
    ...state,
    savedItems: action.payload.savedItems,
    pageNumber: action.payload.pageNumber,
    totalPages: action.payload.totalPages,
    savedItemsLoading: false,
    needUpdate: false
  }),
  [PAGE_CHANGED]: (state, action) => ({
    ...state,
    pageNumber: action.payload.page,
    needUpdate: true
  }),
  [RELOAD]: state => ({
    ...state,
    needUpdate: true
  }),
  [SORT_BY_CHANGED]: (state, action) => ({
    ...state,
    sortBy: action.payload.sortBy,
    needUpdate: true
  }),
  [CLEAR_SAVED_ITEMS]: state => ({
    ...state,
    savedItems: [],
    pageNumber: 1,
    totalPages: 1,
    needUpdate: false
  }),
  [REQUEST_FOLDERS]: state => ({
    ...state,
    foldersLoading: true
  }),
  [RECEIVED_FOLDERS]: (state, action) => ({
    ...state,
    folders: action.payload.folders,
    foldersLoading: false
  }),
  [FOLDERS_REQUEST_FAILED]: state => ({
    ...state,
    folders: { global: [], user: [] },
    foldersLoading: false
  }),
  [FOLDER_SELECTED]: (state, action) => ({
    ...state,
    selectedFolder: action.payload.folderId,
    needUpdate: true
  }),
  [FOLDER_REMOVED]: (state, action) => ({
    ...state,
    selectedFolder: action.payload.folderId === state.selectedFolder ? null : state.selectedFolder
  }),
  [LOAD_SAVED_ITEM]: state => ({
    ...state,
    savedItemLoading: true
  }),
  [LOAD_SAVED_ITEM_FAILED]: state => ({
    ...state,
    savedItemLoading: false
  }),
  [SAVED_ITEM_LOADED]: state => ({
    ...state,
    savedItemLoading: false
  }),
  [SAVED_ITEM_REMOVED]: (state, action) => {
    const index = state.savedItems.map(s => s.id).indexOf(action.payload.id);
    console.log(state.savedItems.map(s => s.id).indexOf(action.payload.id));
    console.log(index);

    if (index >= 0) {
      return update(state, {
        savedItems: { $splice: [[index, 1]] }
      });
    }
    return state;
  }
};

export default function savedItems(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./app/reducers/savedItems.js